<script>
export default {
  name: "advertisementOne",
  props: {
    propsImage: String,
    propsClick: String
  }
};
</script>

<template>
  <el-row style="padding: 40px 0 40px 0; background-color: #ffffff">
    <el-col :span="24" style="display: flex; justify-content: center">
      <a
        id="homePageCreativeAdsPolePosition"
        :href="propsClick"
        style="display: flex;justify-content: center;"
        target="_blank"
      >
        <img :src="propsImage" class="image-ad" loading="lazy"
      /></a>
    </el-col>
  </el-row>
</template>

<style scoped>
.image-ad {
  width: 98%;
  height: 126px;
}

@media only screen and (max-width: 375px) {
  .image-ad {
    width: 98%;
    height: 105px;
  }
}

@media only screen and (min-width: 600px) and (max-width: 1300px) {
  .image-ad {
    width: 98%;
    height: 100%;
  }
}

@media only screen and (min-width: 1301px) {
  .image-ad {
    width: 98%;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/package/advertisementOne.vue